import React, { useState, Suspense } from 'react';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import { FormContainer } from '../CreateForm.styles';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
import CompaniesDataProvider from '../../../Utils/Companies/CompaniesDataProvider';
const CreateDiscount = React.lazy(() => import('./CreateDiscount.component'));
const AllDiscountCodes = React.lazy(() => import('./AllDiscounts'));
const EditDiscountCode = React.lazy(() => import('./EditDiscount.component'));

const DiscountHomepage = () => {
  const [editDiscount, setEditDiscount] = useState(false);
  const [discount, setDiscount] = useState(null);

  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Create Discount Code"
        description="Form for creating a discount code"
      />
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs one="Admin Dashboard" oneLink="/admin" two="Discounts" />
        </Suspense>
        <h2>Discounts</h2>
        <CompaniesDataProvider>
          {(companies) => (
            <Suspense fallback={<p>Loading discount form...</p>}>
              {editDiscount ? (
                <EditDiscountCode
                  discount={discount}
                  setDiscount={setDiscount}
                  companies={companies}
                  setEditDiscount={setEditDiscount}
                />
              ) : (
                <CreateDiscount companies={companies} />
              )}
            </Suspense>
          )}
        </CompaniesDataProvider>
        <Suspense fallback={<p>Loading discount codes...</p>}>
          <AllDiscountCodes
            setEditDiscount={setEditDiscount}
            setDiscount={setDiscount}
          />
        </Suspense>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default DiscountHomepage;
